var React = require('react');

function IconCartInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 1)","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M16.732 7a.997.997 0 0 1 .997.916l1.092 13a.997.997 0 0 1-.878 1.077L2.175 22a.997.997 0 0 1-1-.965L2.272 7.916A.997.997 0 0 1 3.268 7z","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("rect",{"fill":"currentColor","x":"1","y":"17","width":"18","height":"2","rx":"1","key":1}),React.createElement("path",{"d":"M6 7V3.5C6.333 1.167 7.667 0 10 0s3.667 1.167 4 3.5V7","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":2})]));
}

IconCartInline.defaultProps = {"width":"20","height":"24","viewBox":"0 0 20 24"};

module.exports = IconCartInline;

IconCartInline.default = IconCartInline;
